// extracted by mini-css-extract-plugin
export default {"card":"Card_card__RZgo1","action":"Card_action__Eokkb"};